import React from 'react'

import { TextField ,Grid, Typography} from "@mui/material"
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import BooleanFilter from '../../core/form/BooleanFilter';
import { useSelector, useDispatch } from 'react-redux';
import { setCampaignFilterCriteria } from 'store/slice/ManufSlice';

export default function CampaignFilterCriteria() {
    const dispatch = useDispatch();
    const {filterCriteria} = useSelector((state)=>state.manufslice.campaignDashboard);
        
    const {audienceList} = useSelector((state)=>state.manufslice);    
    const {templateList} = useSelector((state)=>state.manufslice);
    
const updateAudienceemailCriteria = (audienceemail) =>{
        dispatch(setCampaignFilterCriteria(
            {
                ...filterCriteria,
                audienceemail:audienceemail
        }))
    }
const updateTemplatenameCriteria = (templatename) =>{
        dispatch(setCampaignFilterCriteria(
            {
                ...filterCriteria,
                templatename:templatename
        }))
    }

    return (

        <Grid container direction="row" lg={12} sx={{justifyContent:'center'}}>
                    <Grid item lg={4} padding={1}>
                        <TextField type="search" variant="standard"
                            label="Templatename"
                            name="templatename"
                            value={filterCriteria.templatename}
                            onChange={(e)=>updateTemplatenameCriteria(e.target.value)}
                            sx={{minWidth:'100px'}}
                        />
                    </Grid>


        </Grid>
    )

}